import pluralize from "pluralize";

//#region src/timeUtils.ts
function formatReadingTime(readingTime, unit = "minute") {
	if (!readingTime) return "";
	return pluralize(`${readingTime} ${unit}`, readingTime);
}

//#endregion
export { formatReadingTime };